import { useContext } from 'react';
import {
  H3,
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@vp/swan';

import { DebugExperimentsControls } from './DebugExperimentsControls';
import { ExperimentsContext } from '../../contexts/ExperimentsContext';

export const DebugExperimentsPanel = () => {
  const { activeExperiments } = useContext(ExperimentsContext) || {
    activeExperiments: [],
  };

  if (!activeExperiments || activeExperiments.length < 1) {
    return (
      <div>
        <Typography>It appears you have no active experiments.</Typography>
      </div>
    );
  }

  return (
    <Table>
      <TableCaption>
        <H3 visuallyHidden>Experiments</H3>
      </TableCaption>
      <TableHead>
        <TableRow>
          <TableCell id="mod-family-label">Experiment keys</TableCell>
          <TableCell id="mod-id-label">Variation keys</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {activeExperiments.map((activeExperiment, index) => (
          <TableRow key={`debug-experiment-${index}`}>
            <DebugExperimentsControls
              experimentKey={activeExperiment.experimentKey}
              variationKey={activeExperiment.variationKey}
              availableVariationKeys={activeExperiment.availableVariationKeys}
              key={index}
            />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
